import React from "react";
import Modal from "./Modal";
import Button from "./Button";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  variant?: "default" | "danger";
}

const ConfirmDialog: React.FC<Props> = ({
  isOpen, onClose, onConfirm, title, message, confirmLabel = "Delete", variant = "default"
}) => (
  <Modal isOpen={isOpen} onClose={onClose} title={title} width="max-w-md">
    <div className="space-y-5">
      <div className="flex gap-4">
        <div className="w-12 h-12 rounded-2xl bg-red-50 flex items-center justify-center text-2xl flex-shrink-0">
          ⚠️
        </div>
        <p className="text-gray-600 text-sm leading-relaxed pt-1">{message}</p>
      </div>
      <div className="flex gap-3 justify-end pt-2 border-t border-gray-100">
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="danger" onClick={() => { onConfirm(); onClose(); }}>
          {confirmLabel}
        </Button>
      </div>
    </div>
  </Modal>
);

export default ConfirmDialog;
